module.exports = __webpack_public_path__ + "media/images/fmdd_loading-0b426f5d826518021f9fbc851c86986d.gif";